"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _redux = require("redux");

var _reduxSaga = _interopRequireDefault(require("redux-saga"));

var _reducer = _interopRequireDefault(require("./reducer"));

var _sagas = _interopRequireDefault(require("./sagas"));

function _default(initialState) {
  var sagaMiddleware = (0, _reduxSaga["default"])({
    onError: function onError() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var err = args[0];
      console.error(err);
      store.dispatch({
        type: 'WEB_CHAT/SAGA_ERROR'
      });
    }
  });

  for (var _len = arguments.length, middlewares = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    middlewares[_key - 1] = arguments[_key];
  }

  var store = (0, _redux.createStore)(_reducer["default"], initialState || {}, _redux.applyMiddleware.apply(void 0, middlewares.concat([sagaMiddleware])));
  sagaMiddleware.run(_sagas["default"]);
  return store;
}